define(["underscore","jquery","@bingads-webui/http-util","@bingads-webui/url-util"], function(__WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__43__, __WEBPACK_EXTERNAL_MODULE__44__, __WEBPACK_EXTERNAL_MODULE__373__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 370);
/******/ })
/************************************************************************/
/******/ ({

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(371);


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "KeepAlive", {
  enumerable: true,
  get: function get() {
    return _src.KeepAlive;
  }
});
Object.defineProperty(exports, "keepAliveInstance", {
  enumerable: true,
  get: function get() {
    return _src.keepAliveInstance;
  }
});

var _src = __webpack_require__(372);

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keepAliveInstance = exports.KeepAlive = void 0;

var _jquery = _interopRequireDefault(__webpack_require__(43));

var _underscore = _interopRequireDefault(__webpack_require__(8));

var urlUtil = _interopRequireWildcard(__webpack_require__(373));

var _httpUtil = __webpack_require__(44);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const checkFrequencyInMinutes = 5;

function fullFillUrl(relativeUrl) {
  const domain = urlUtil.getDomain(window.location.href);
  return `${window.location.protocol}//${domain.replace(/ui\./i, '')}${relativeUrl}`;
}

class KeepAlive {
  /**
   * initialize Keep Alive Class
   * @param {object} [deps] - provide dep injection for keep alive
   * @param {string} [url] - url to keep alive, if pass absolute url, rewrite url will be useless
   * @param {function} [reWriteUrl] - function to rewrite url when pass relative url
   * @param {number} [timeoutInMinutes] - user is idle but we keep session alive duration
   * @param {function} [unAuthCallBack] - call back when get 401 from keep alive
   * @returns {void}
   */
  constructor({
    deps = {
      httpUtil: _httpUtil.http
    },
    url = '/root/keepalive?__adcenterAJAX=true',
    requestOption = {
      converters: {
        'text json': function textJson(data) {
          if (_underscore.default.isEmpty(data)) {
            return null;
          }

          return JSON.parse(data);
        }
      },
      xhrFields: {
        withCredentials: true
      },
      contentType: 'application/x-www-form-urlencoded'
    },
    reWriteUrl = fullFillUrl,
    timeoutInMinutes = 240,
    unAuthCallBack = _underscore.default.identity
  }) {
    this.url = url;

    if (urlUtil.isRelativeUrl(url)) {
      this.url = reWriteUrl(url);
    }

    this.deps = deps;
    this.keepAliveTask = null;
    this.checkFrequency = checkFrequencyInMinutes * 1000 * 60;
    this.keepAliveCounter = 0;
    this.keepAliveMaxCount = timeoutInMinutes / checkFrequencyInMinutes;
    this.unAuthCallBack = unAuthCallBack;
    this.requestOption = requestOption;
  }

  issueKeepAliveRequest() {
    return this.deps.httpUtil.get(this.url, this.requestOption).then((data = {}) => {
      if (_underscore.default.result(data, 'Error') === '401') {
        this.unAuthCallBack(data);
        return false;
      }

      return true;
    }).catch(reason => {
      if (_underscore.default.result(reason, 'status') === 200) {
        return true;
      }

      return false;
    }).then(result => {
      if (result) {
        this.keepAliveCounter = this.keepAliveCounter + 1;
      }

      return result;
    });
  }

  issueKeepAliveRequestWithExceptionHandling() {
    try {
      this.issueKeepAliveRequest(); // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  start() {
    this.stop();
    this.issueKeepAliveRequestWithExceptionHandling();
    this.keepAliveTask = setInterval(() => {
      if (this.keepAliveCounter <= this.keepAliveMaxCount) {
        this.issueKeepAliveRequestWithExceptionHandling();
      }
    }, this.checkFrequency);
    (0, _jquery.default)(window).on('unload', () => this.stop());
  }

  stop() {
    if (this.keepAliveTask !== null) {
      clearInterval(this.keepAliveTask);
      this.keepAliveTask = null;
    }
  }

  refresh() {
    this.keepAliveCounter = 0;
  }

}

exports.KeepAlive = KeepAlive;
const keepAliveInstance = new KeepAlive({});
exports.keepAliveInstance = keepAliveInstance;

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__373__;

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__43__;

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__44__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ })});;
